import { BigNumber } from 'bignumber.js'

import { defineNuxtPlugin } from '#imports'

// BigNumberのデフォルト設定
BigNumber.config({
  // 小数第24位まで考慮
  DECIMAL_PLACES: 24,
})

export default defineNuxtPlugin(() => {})
